<template>
  <div class="comp">
    <el-dialog
      :title="''"
      :visible.sync="dialogState"
      width="1200px"
      @close="submit('close')"
    >
      <div class="label">更换前</div>
      <div class="tableBox">
        <el-table border :data="[oldGoods]">
          <el-table-column label="名称" prop="goodsName" width="200">
          </el-table-column>
          <el-table-column label="规格" prop="skuValue" width="120">
          </el-table-column>
          <el-table-column label="数量" prop="num" width="80">
          </el-table-column>
          <el-table-column label="单位(元)" prop="unit" width="90">
          </el-table-column>
          <el-table-column label="出库量" width="150">
            <template slot-scope="props">
              <div class="cishu">
                <el-input
                  :disabled="!$public.isNull(props.row.orderNum)"
                  v-model="props.row.goodsDosage"
                  @input="changeDosage(props.row)"
                  style="width: 80px"
                >
                  <template slot="append" style="padding: 0">{{
                    props.row.outUnit
                  }}</template>
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="price"> </el-table-column>
          <el-table-column label="换算单位" width="120">
            <template slot-scope="props">
              {{ props.row.unit_changesrc }}={{ props.row.unit_changedesc }}
            </template>
          </el-table-column>
          <el-table-column label="库存" prop="goods_name" width="60">
          </el-table-column>
          <el-table-column label="支付状态">
            <template slot-scope="props">
              <span v-if="props.row.isPay == 1" style="color: #18a44c"
                >已支付</span
              >
            </template>
          </el-table-column>
          <el-table-column label="小计">
            <template slot-scope="props">
              {{ $public.getSubtotal(props.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="goods_name"> </el-table-column>
        </el-table>
      </div>
      <div class="label">更换后</div>
      <div class="tableBox">
        <el-table border :data="newGoodsList">
          <el-table-column label="名称" prop="goodsName" width="200">
          </el-table-column>
          <el-table-column label="规格" prop="skuValue" width="120">
          </el-table-column>
          <el-table-column label="数量" prop="num" width="80">
            <template slot-scope="props">
              <el-input
                v-model="props.row.num"
                @input="changeNum(props.row)"
                style="width: 55px"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位(元)" prop="unit" width="90">
          </el-table-column>
          <el-table-column label="出库量" width="150">
            <template slot-scope="props">
              <div class="cishu">
                <el-input
                  :disabled="!$public.isNull(props.row.orderNum)"
                  v-model="props.row.goodsDosage"
                  @input="changeDosage(props.row)"
                  style="width: 80px"
                >
                  <template slot="append" style="padding: 0">{{
                    props.row.outUnit
                  }}</template>
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="price"> </el-table-column>
          <el-table-column label="换算单位" width="120">
            <template slot-scope="props">
              {{ props.row.unit_changesrc }}={{ props.row.unit_changedesc }}
            </template>
          </el-table-column>
          <el-table-column label="库存" prop="stock" width="60">
          </el-table-column>
          <el-table-column label="支付状态">
            <template>
              <span style="color: red">未支付</span>
            </template>
          </el-table-column>
          <el-table-column label="小计">
            <template slot-scope="props">
              {{ $public.getSubtotal(props.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="goods_name">
            <template slot-scope="props">
              <el-button
                type="danger"
                @click="deleteGoods(props.row, props.$index)"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="color: red; padding: 10px 0" v-if="replaceRate < 1">
          更换商品默认执行{{ $public.cheng(replaceRate, 10) }}折优惠
        </div>
        <div style="text-align: center; padding: 20px 0">
          <el-button type="primary" @click="addGoods">添加</el-button>
        </div>
        <span>差价：</span
        ><span style="margin-right: 50px">{{ diffPrice }}元</span>
        <span>是否补齐差价：</span
        ><el-radio-group
          :disabled="diffPrice === 0"
          style="margin-right: 100px"
          v-model="isMakeUp"
        >
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submit('cancel')">取 消</el-button>
        <el-button type="primary" @click="submit('submit')">确 定</el-button>
      </div>
    </el-dialog>
    <div v-if="dialogAddGoods_state">
      <dialogAddShop
        :addShopState="dialogAddGoods_state"
        :shopId="curShopId"
        :tree="[
          {
            id: '602f1e88c904d9db7ccf3bec',
            children: [
              { id: '602f1e88c904d9db7ccf3bed' },
              { id: '602f1e88c904d9db7ccf3bf2' },
              { id: '602f1e89c904d9db7ccf3bf6' },
              { id: '602f1e89c904d9db7ccf3bf8' },
              { id: '602f1e89c904d9db7ccf3bfc' },
              { id: '602f1e89c904d9db7ccf3bff' },
            ],
          },
        ]"
        @submit="selectGoods"
        @closeOn="dialogAddGoods_state = false"
      ></dialogAddShop>
    </div>
  </div>
</template>
<script>
import dialogAddShop from "./dialog_addShop.vue";
export default {
  components: { dialogAddShop },
  data() {
    return {
      dialogState: true,
      dialogAddGoods_state: false,
      total: {
        total: 0,
      },
      newGoodsList: [],
      beforeGoods: {},
      afterGoods: [],
      isMakeUp: false,
    };
  },
  computed: {
    diffPrice() {
      let p =
        this.$public.jian(
          this.total.total,
          this.oldGoods.allow_wholesale === 1
            ? this.$public.cheng(this.oldGoods.price, this.oldGoods.num)
            : this.$public.cheng(
                this.oldGoods.price,
                this.oldGoods.countPriceDosage
              )
        ) || 0;
      return p;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  watch: {
    diffPrice(n) {
      console.log(n);
      if (n === 0) {
        this.isMakeUp = false;
      } else {
        this.isMakeUp = true;
      }
    },
  },
  props: {
    replaceRate: {
      defalut: 1,
    },
    oldGoods: {
      type: Object,
      default: () => {
        return {};
      },
    },
    posi: {
      type: Array,
      default: () => {
        return [-1, -1];
      },
    },
  },
  mounted() {
    console.log("replaceRate", this.replaceRate);
  },
  methods: {
    // 改变数量
    changeNum(row) {
      row.num = Math.floor(row.num);
      row.num = this.$public.replaceGoodsDosage(row.num);
      let stock = 0;
      console.log(row);
      if (row.skuStocks) {
        if (row.skuStocks.length > 0) {
          stock = this.$public.getMatchingItem(
            row.skuStocks[row.skuValueIndex].lstStock,
            "shopId",
            this.curShopId
          ).stock;
          let totalTimes = this.$public.getMatchingItem(
            row.skuStocks[row.skuValueIndex].lstStock,
            "shopId",
            this.curShopId
          ).totalTimes;
          if (row.num > stock) {
            this.$message({
              message: "该药品最大数量为" + stock,
              type: "error",
            });
            row.num = stock;
          }
          let goodsDosage = this.$public.cheng(row.num, row.in_exchanage);
          if (goodsDosage > totalTimes) {
            row.goodsDosage = totalTimes;
          } else {
            row.goodsDosage = goodsDosage;
          }
        }
      }
      this.getTotal();
    },
    changeDosage(row) {
      row.goodsDosage = this.$public.replaceGoodsDosage(row.goodsDosage);
      let totalTimes = this.$public.getMatchingItem(
        row.skuStocks[row.skuValueIndex].lstStock,
        "shopId",
        this.curShopId
      ).totalTimes;
      if (row.goodsDosage > totalTimes) {
        this.$message({
          message: "该药品最大用量为" + totalTimes,
          type: "error",
        });
        row.goodsDosage = totalTimes;
      }
      let num = Math.ceil(
        this.$public.chu(Number(row.goodsDosage), row.in_exchanage)
      );
      row.num = num;
      this.$nextTick(() => {
        this.getTotal();
      });
    },
    submit(str) {
      if (str == "close") {
        this.$emit("submit", { type: str });
      } else if (str == "cancel") {
        this.$emit("submit", { type: str });
      } else if (str == "submit") {
        for (let i = 0; i < this.newGoodsList.length; i++) {
          if (!Number(this.newGoodsList[i].num)) {
            this.$message({
              message: this.newGoodsList[i].goodsName + " 商品数量有误",
              type: "error",
            });
            return;
          }
          if (
            Number(this.newGoodsList[i].num) >
            Number(this.newGoodsList[i].stock)
          ) {
            this.$message({
              message: this.newGoodsList[i].goodsName + " 库存不足",
              type: "error",
            });
            return;
          }
        }
        this.resetGoods();

        this.$emit("submit", {
          type: str,
          posi: this.posi,
          isMakeUp: this.isMakeUp,
          beforeGoods: this.beforeGoods,
          afterGoods: this.afterGoods,
        });
      }
    },
    // 添加
    addGoods() {
      this.dialogAddGoods_state = true;
    },
    // 删除商品
    deleteGoods(row, propsIndex) {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log("del", row, propsIndex);
        this.newGoodsList.splice(propsIndex, 1);
        this.getTotal();
      });
    },
    selectGoods({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods_state = false;
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.newGoodsList;
      for (let i = 0; i < table.length; i++) {
        if (table[i].skus == row.skus && table[i].goodsId == row.goodsId) {
          this.$message({
            message: "该商品已添加",
            type: "error",
          });
          return;
        }
      }
      if (row.stock == 0) {
        this.$message({
          message: "该商品已没有库存，请及时申请采购",
          type: "error",
        });
        return;
      }
      this.$util.getGoodsInfo([row], 1).then((goodsList) => {
        for (let i = 0; i < goodsList.length; i++) {
          this.$set(row, "skuValueIndex", 1);
          for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
            if (goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue) {
              this.$set(goodsList[i], "skuValueIndex", a);
              this.$set(
                goodsList[i],
                "originalPrice",
                this.$public.getCFPrice(
                  goodsList[i].allow_wholesale,
                  goodsList[i].in_exchanage,
                  goodsList[i].skuStocks[a].salePrice
                )
              );
              this.$set(goodsList[i], "skus", goodsList[i].skuStocks[a].skus);
              this.$set(
                goodsList[i],
                "skuValue",
                goodsList[i].skuStocks[a].skuValue
              );
            }
          }
        }
        row.index = table.length;
        table.push(row);

        this.$nextTick(() => {
          this.getTotal();
        });
        this.$message({
          message: "添加成功",
          type: "success",
        });
      });
      // row.originalPrice = this.$public.cheng(row.originalPrice,this.replaceRate)
      // row.price = this.$public.cheng(row.price,this.replaceRate)
      // table.push(row)
      // this.$message({
      // 	message: '添加成功',
      // 	type: 'success'
      // });
      // this.getTotal()
    },
    getTotal() {
      this.$nextTick(() => {
        this.resetGoods();
        let total = 0;
        for (let i = 0; i < this.afterGoods.length; i++) {
          let goods = this.afterGoods[i];
          if (goods.allowWholesale === 1) {
            total = this.$public.jia(
              total,
              this.$public.cheng(goods.price, goods.num)
            );
          } else {
            total = this.$public.jia(
              total,
              this.$public.cheng(goods.price, goods.countPriceDosage)
            );
          }
        }
        this.total.total = total;
      });
    },
    resetGoods() {
      let afterGoods = [];
      let table = this.newGoodsList;
      for (let i = 0; i < table.length; i++) {
        let newGoods = {
          brand: table[i].brand,
          categoryId: table[i].categoryId,
          categoryName: table[i].categoryName,
          goodsList: [],
          goodsId: table[i].goodsId,
          goodsName: table[i].goodsName,
          isHumanMedication: table[i].isHumanMedication,
          otherName: table[i].otherName,
          goodsType: table[i].goodsType,
          skus: this.$public.isNull(table[i].skus) ? "" : table[i].skus,
          skuValue: this.$public.isNull(table[i].skuValue)
            ? ""
            : table[i].skuValue,
          model: table[i].model,
          unit: table[i].unit,
          originalPrice: table[i].originalPrice,
          price: table[i].price,
          num: table[i].num,
          notCount: !this.isMakeUp,
          activityId: "",
          activityName: "",
          totalMoney: this.$public.cheng(table[i].num, table[i].price),
          goodsUsage: "",
          goodsDosage: table[i].goodsDosage,
          goodsTimes: "",
          remark: table[i].remark,
          extendContent: table[i].extendContent,
          isNeedCode: table[i].isNeedCode, // 是否有耗材
        };
        newGoods.allowWholesale = table[i].allow_wholesale;
        newGoods.dosageCeiling = table[i].dosageCeiling;
        newGoods.dosageCeilingValue = table[i].dosageCeilingValue;
        newGoods.countPriceDosage = table[i].countPriceDosage;
        newGoods.outUnit = table[i].outUnit;
        afterGoods.push(newGoods);
      }
      this.afterGoods = afterGoods;

      this.beforeGoods = {
        brand: this.oldGoods.brand,
        categoryId: this.oldGoods.categoryId,
        categoryName: this.oldGoods.categoryName,
        goodsList: [],
        id: this.oldGoods.id,
        itemsId: this.oldGoods.itemsId,
        goodsId: this.oldGoods.goodsId,
        goodsName: this.oldGoods.goodsName,
        goodsType: this.oldGoods.goodsType,
        skus: this.oldGoods.skus,
        skuValue: this.oldGoods.skuValue,
        model: this.oldGoods.model,
        unit: this.oldGoods.unit,
        originalPrice: this.oldGoods.originalPrice,
        price: this.oldGoods.price,
        num: this.oldGoods.num,
        notCount: this.isMakeUp,
        activityId: "",
        activityName: "",
        totalMoney: this.oldGoods.totalMoney,
        goodsUsage: "",
        goodsDosage: this.oldGoods.goodsDosage,
        goodsTimes: "",
        remark: this.oldGoods.remark,
        extendContent: this.oldGoods.extendContent,
        isNeedCode: this.oldGoods.isNeedCode, // 是否有耗材
      };
      this.beforeGoods.allowWholesale = this.oldGoods.allow_wholesale;
      this.beforeGoods.outUnit = this.oldGoods.outUnit;
    },
  },
};
</script>
<style lang="scss" scoped>
.comp {
  .label {
    padding: 20px 0 10px;
  }
  .cishu {
    display: flex;
    ::v-deep .el-input__inner {
      padding: 0 5px;
    }
    ::v-deep .el-input-group__append {
      padding: 0 3px;
    }
  }
}
</style>
